//
//
//
//
//
//

import index from './index';
export default {
  name: 'IChecked',
  components: {
    index: index
  }
};